import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Option } from '../../models/selectedOptions.interface';

@Component({
  selector: 'app-selection-buttons',
  templateUrl: './selection-buttons.component.html',
  styleUrls: ['./selection-buttons.component.scss'],
})
export class SelectionButtonsComponent implements OnInit {
  @Input() type: 'two' | 'three';
  @Input() options: Option[];
  @Input() defaultSelected: number | string; // this input is not required, but can be used if needed

  // outputs the value of the option that is selected
  @Output() optionSelected = new EventEmitter<string>();

  selected: number;

  constructor() {}

  ngOnInit(): void {
    this.setDefaultSelected(this.defaultSelected);
  }

  setDefaultSelected(defaultSelected: number | string): void {
    if (defaultSelected !== undefined) {
      if (typeof defaultSelected === 'string') {
        this.options.forEach((o, i) => {
          if (o.value === defaultSelected) {
            this.selected = i;
          }
        });

        // if the default value passed in does not exist on the options object
        if (this.selected === undefined) {
          this.selected = 0;
        }
      } else {
        if (defaultSelected >= 0 && defaultSelected <= 2) {
          this.selected = defaultSelected;
        } else {
          // if the number is not within the allowed range, set selected to 0
          this.selected = 0;
        }
      }
    } else {
      this.selected = 0;
    }
  }

  get isTwo(): boolean {
    return this.type === 'two';
  }

  setSelected(val: number): void {
    this.selected = val;
    this.optionSelected.emit(this.options[val].value);
  }

  get option1(): string {
    return this.options[0].name;
  }
  get option2(): string {
    return this.options[1].name;
  }
  get option3(): string {
    return this.options[2].name;
  }
}
